import React from 'react';
import { CardMetric, CardMetricBody, CardMetricHeader, CardMetricTitle, CardMetricValue } from '@/components/ui/card-metric';

export function WidgetKpi({ title = 'Widget title', children, className, variant }) {
  return (
    <CardMetric
      variant={variant}
      className={className}
    >
      <CardMetricHeader>
        <CardMetricTitle>{title}</CardMetricTitle>
      </CardMetricHeader>
      <CardMetricBody>{children}</CardMetricBody>
    </CardMetric>
  );
}

export function WidgetKpiValue({ children }) {
  return <CardMetricValue>{children}</CardMetricValue>;
}
